<div *ngIf="pageLoaderVm as vm">

    <!-- working -->
    <div *ngIf="vm.workingText">
        <div class="row">
            <div class="col-md-12 text-center mt-5">
                <span class="h3-responsive mr-2 mt-4">{{vm.workingText}}</span>
            </div>
            <div class="col-md-12 text-center mt-5">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </div>
        </div>
    </div>

    <!-- error -->
    <div *ngIf="vm.errorText">
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <span class="text-danger">{{vm.errorText}}</span>
            </div>
        </div>
    </div>

</div>